














import { Component, Prop, Mixins } from 'vue-property-decorator';

import { MixinChartGroupEvolution } from '@/plugins/podolib/services/helper/mixins/chart/evolution';

import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';
import { TMode } from '@/plugins/podolib/services/helper/mixins/chart';
//
import ChartEvolutionStancePhaseFlatFoot from '@/components/charts/evolution/ChartEvolutionStancePhaseFlatFoot.vue';
import ChartEvolutionRunningStrikePattern from '@/components/charts/evolution/ChartEvolutionRunningStrikePattern.vue';
import ChartEvolutionRunningForceImpact from '@/components/charts/evolution/ChartEvolutionRunningForceImpact.vue';

@Component({
  components: {
    ChartEvolutionStancePhaseFlatFoot,
    ChartEvolutionRunningStrikePattern,
    ChartEvolutionRunningForceImpact,
  },
})
export default class ChartsGroupEvolutionNewRunningParameters extends Mixins(MixinChartGroupEvolution) {
  @Prop({ required: true }) protected acquisitions!: TAcquisition[];
  @Prop({ required: true }) protected mode!: TMode;
}
